var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.data.name))]),_c('div',{staticClass:"barbg"},[_c('div',{staticClass:"bar",style:({
        'background-color': _vm.data.color,
        width: (1000 * _vm.data.value) / _vm.data.max + 'px',
      })})]),_c('num-field',{attrs:{"value":_vm.data.value,"numSize":80,"digit":_vm.data.digit||0,"unit":_vm.data.unit||'',"unitSize":40,"unitColor":"#697c94"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }